import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "./apiSlice";
import paperReducer from './paperSlice';
import languageReducer from './languageSlice';
import userReducer from "./userSlice";

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("userState");
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Could not load state", e);
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("userState", serializedState);
  } catch (e) {
    console.error("Could not save state", e);
  }
};

const preloadedState = loadState();

export const store = configureStore({
  reducer: {
    user: userReducer,
    paper: paperReducer,
    language: languageReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  preloadedState, 
});

store.subscribe(() => {
  saveState({
    user: store.getState().user, 
  });
});


setupListeners(store.dispatch);
export default store;